const GET_MOUNTED_COURSE = (state) => {
  return state.mounted_course;
};
const GET_LESSON_SELECTED = (state) => {
  return state.lesson_selected;
};

export default {
  GET_MOUNTED_COURSE,
  GET_LESSON_SELECTED,
};
